export const makeTableRows = arr =>
  arr.map(f => ({
    ...f,
    location_name: f.location.name,
    packet_original_filename: f.shift.name,
    canvasser_full_name: f.canvasser.full_name,
  }))
